import { api } from "../api";

/**
 * findAllEventTypesListResponse - Function that finds on database all events types suported as select list response  
 * /events/types    
 * method GET 
 * @async-function
 */
const findAllEventTypesListResponse = async (token: string) => {
    const response = await api.get(
        `/events/types`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};
export default findAllEventTypesListResponse;